import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";

const PlanForSuccess = () => {
  const navigate = useNavigate();

  const [activePlanSteps, setActivePlanSteps] = useState(() => {
    const savedSteps = localStorage.getItem("activePlanSteps");
    return savedSteps ? JSON.parse(savedSteps) : [1];
  });

  useEffect(() => {
    localStorage.setItem("currentPlanIndex", 0);
    localStorage.setItem("currentNext30Index", 0);
    localStorage.setItem("currentIndex", 0);
    localStorage.setItem("prevMessagePage", false);
  }, []);

  const handleStepClick = (step) => {
    setActivePlanSteps((prevSteps) => {
      if (!prevSteps.includes(step)) {
        const updatedSteps = [...prevSteps, step];
        localStorage.setItem("activePlanSteps", JSON.stringify(updatedSteps));
        return updatedSteps;
      }
      return prevSteps;
    });
  };

  const navigateToStep = (step, driver) => {
    navigate(`/plan-for-success/${driver}`);
    handleStepClick(step);
  };

  const editStep = (step, driver) => {
    navigate(`/plan-for-success/${driver}/edit`);
    handleStepClick(step);
  };

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="driver-auth-view__container">
            <div className="driver-view">
              <div className="driver-heading">PLAN FOR SUCCESS</div>
              <form className="driver-form">
                <div className="driver-view__field">
                  <ReactPlayer
                    url="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-12-plan-for-success.mp4"
                    config={{
                      vimeo: {
                        playerOptions: {
                          title: true,
                          byline: false,
                          portrait: false,
                        },
                      },
                    }}
                    controls={true}
                    width="100%"
                    height="100%"
                  />
                </div>

                <form className="driver-steps-form">
                  {/* Step 1 */}
                  <div className="driver-step-btn">
                    <button
                      type="button"
                      className="driver-btn"
                      style={{
                        width: "480px",
                        margin: "1rem 0",
                        backgroundColor:
                          activePlanSteps.length === 1 ? "#d1b794" : "#26262f",
                        cursor: activePlanSteps.includes(1)
                          ? "pointer"
                          : "not-allowed",
                      }}
                      onClick={() =>
                        activePlanSteps.length > 1
                          ? editStep(2, "next90")
                          : navigateToStep(2, "next90")
                      }
                    >
                      <span
                        className="driver-button__label"
                        style={
                          activePlanSteps.length > 1
                            ? { color: "#d1b794" }
                            : { color: "#fff" }
                        }
                      >
                        {activePlanSteps.length > 1
                          ? "Edit your Quarterly Targets"
                          : "Step 4 | Quarterly Targets NEXT 90"}
                      </span>
                    </button>
                    <div
                      style={{ cursor: "pointer", color: "#d1b794" }}
                      onClick={() => handleStepClick(2)}
                    >
                      {activePlanSteps.length === 1 && "Skip for now"}
                    </div>
                  </div>

                  {/* Step 2 */}
                  <div className="driver-step-btn">
                    <button
                      type="button"
                      className="driver-btn"
                      style={{
                        width: "480px",
                        margin: "1rem 0",
                        backgroundColor:
                          activePlanSteps.length === 2 ? "#d1b794" : "#26262f",
                        cursor: activePlanSteps.includes(2)
                          ? "pointer"
                          : "not-allowed",
                        border:
                          activePlanSteps.length === 1
                            ? "1px solid #604b51"
                            : "1px solid #d1b794",
                      }}
                      disabled={activePlanSteps.length === 1}
                      onClick={() =>
                        activePlanSteps.length > 2
                          ? editStep(3, "next30")
                          : navigateToStep(3, "next30")
                      }
                    >
                      <span
                        className="driver-button__label"
                        style={
                          activePlanSteps.length === 1
                            ? { color: "#604b51" }
                            : activePlanSteps.length > 2
                            ? { color: "#d1b794" }
                            : { color: "#fff" }
                        }
                      >
                        {activePlanSteps.length > 2
                          ? "Edit your Monthly Targets"
                          : "Step 5 | Monthly Targets NEXT 30"}
                      </span>
                    </button>
                    <div
                      style={
                        activePlanSteps.includes(2)
                          ? {
                              display: "flex",
                              cursor: "pointer",
                              color: "#d1b794",
                            }
                          : { display: "none" }
                      }
                      onClick={() =>
                         handleStepClick(3)
                      }
                    >
                      {activePlanSteps.length === 2 && "Skip for now"}
                    </div>
                  </div>

                  {/* Step 3 */}
                  <div className="driver-step-btn">
                    <button
                      type="button"
                      className="driver-btn"
                      style={{
                        width: "480px",
                        margin: "1rem 0",
                        backgroundColor:
                        activePlanSteps.length === 3 ? "#d1b794" : "#26262f",
                        cursor: activePlanSteps.includes(3)
                          ? "pointer"
                          : "not-allowed",
                          border:
                          activePlanSteps.length < 3
                            ? "1px solid #604b51"
                            : "1px solid #d1b794",
                      }}
                      disabled={!activePlanSteps.includes(3)}
                      onClick={() => navigateToStep(3, "key4")}
                    >
                      <span className="driver-button__label" style={
                          activePlanSteps.length < 3
                            ? { color: "#604b51" }
                            : { color: "#fff" }
                        }>
                        Step 6 | Key 4
                      </span>
                    </button>
                    <div
                      style={
                        activePlanSteps.includes(3)
                          ? {
                              display: "block",
                              cursor: "pointer",
                              color: "#d1b794",
                            }
                          : { display: "none" }
                      }
                      onClick={() => navigate("/message-page")}
                    >
                      Skip for now
                    </div>
                  </div>
                </form>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PlanForSuccess;
